import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import { Alert } from '../../Alert/Alert.js';
import style from './Snackbar.module.scss.js';

const { componentTestLabel, elementTestLabel } = getTestLabels('Snackbar');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=8604-59106&node-type=section&t=EDysr1f69m8d1p4V-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Snackbar/Snackbar/Snackbar.tsx)
 *
 * Individual Snackbar component.
 * Wrap your app in `<SnackbarQueueProvider>` and use `addSnackbar()` method from the `useSnackbarQueue()` hook to send snackbar messages to the queue.
 * See the `SnackbarQueueProvider` storybook docs for more details.
 *
 * @param {string} buttonText - (optional) If `undoButtonText` AND `onUndoButtonClick` are provided, a button will be shown with the corresponding text and click handler.
 * @param {string} closeButtonAriaLabel - (optional, recommended for accessibility) If an `onClose` function is also provided. This text will be used to label the "close" button.
 * @param {function} onButtonClick - (optional) If `onButtonClick` AND `buttonText` are supplied, a button will be shown with the corresponding text and click handler.
 * @param {string} variant - (optional) One of `caution`, `error`, `info` (default), `success`, or `warning` (deprecated alias to `error`).
 *
 */
const Snackbar = forwardRef((props, ref) => {
    const { buttonText, children, className, closeButtonAriaLabel, onButtonClick, onClose, variant, ...otherProps } = props;
    return (jsx("div", { "data-zta": componentTestLabel, ref: ref, ...otherProps, className: classNames(className, style['z-snackbar']), children: jsx(Alert, { "data-zta": elementTestLabel('Alert'), buttonText: buttonText, closeButtonAriaLabel: closeButtonAriaLabel, onButtonClick: onButtonClick, variant: variant, onClose: buttonText && onButtonClick ? undefined : onClose, children: children }) }));
});
Snackbar.displayName = 'Snackbar';

export { Snackbar };
//# sourceMappingURL=Snackbar.js.map
